module.exports = __webpack_public_path__ + "img/timeline_mainevent-5.63457d4f.jpg";